import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DetailSerieBaseComponent } from '@modules/dashboard/components/abstracts/detail-serie-base/detail-serie-base.component';
import { IDetailAuthorizationPerDay } from '@modules/network-manager/pages/smart-olt/definitions/smart-olt.model';
import { ExportDataService } from '@sharedComponents/tables/services/export-data.service';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-detail-authotization-series-per-day',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './detail-authotization-series-per-day.component.html',
})
export class DetailAuthotizationSeriesPerDayComponent extends DetailSerieBaseComponent implements OnInit {
  // IDetailAuthorizationPerDay;

  public data!: IDetailAuthorizationPerDay;
  constructor(
    public override dialogRef: DynamicDialogRef,
    dialogService: DialogService,
    public readonly exportDataService: ExportDataService,
  ) {
    super(dialogRef, dialogService);
  }
  ngOnInit(): void {
    if (this.dialog?.data) {
      this.data = this.dialog.data;
    }
  }
}
